var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fetcher } from "openapi-typescript-fetch";
class PrivateApiClient {
    get access_token() {
        return this.accessToken;
    }
    constructor(baseUrl) {
        this.client = Fetcher.for();
        this.authorizer = (url, init, next) => __awaiter(this, void 0, void 0, function* () {
            const needHeaders = ["selfadjust-extra-damages-estimation"];
            if (!needHeaders.some((path) => url.includes(path))) {
                return yield next(url, init);
            }
            const token = this.access_token;
            if (!token) {
                const body = JSON.parse(init.body);
                init.headers.append("entity_id", body.smartphoto_id);
                init.headers.append("entity_type", "selfadjust");
                init.headers.append("company_id", body.company_id);
                return yield next(url, init);
            }
            init.headers.append("access_token", token);
            return yield next(url, init);
        });
        this.motor = {
            smartphoto: {
                get: this.client.path("/selfadjust-get").method("post").create(),
                update: this.client.path("/selfadjust-update").method("post").create(),
                pushImage: this.client
                    .path("/selfadjust-pushimage")
                    .method("post")
                    .create(),
                damageSummary: {
                    update: this.client
                        .path("/damage-summary-feedback")
                        .method("post")
                        .create(),
                },
                damage: {
                    price: this.client
                        .path("/selfadjust-extra-damages-estimation")
                        .method("post")
                        .create(),
                },
                company: this.client.path("/selfadjust-company").method("post").create(),
                getExternalEstimate: this.client
                    .path("/get-external-estimate")
                    .method("post")
                    .create(),
            },
            company: {
                get: this.client.path("/company-view").method("post").create(),
                agents: this.client.path("/company-users").method("post").create(),
            },
            historyLogs: {
                get: this.client.path("/historylog-get").method("post").create(),
            },
            shared: {
                selector: {
                    get: this.client.path("/static-selectors").method("post").create(),
                },
                notification: {
                    resend: this.client.path("/resend-sms").method("post").create(),
                },
            },
        };
        this.platform = {
            auth: {
                login: this.client.path("/login").method("post").create(),
            },
            user: {
                create: this.client.path("/user-create").method("post").create(),
                get: this.client.path("/user-view").method("post").create(),
                update: this.client.path("/user-update").method("post").create(),
                me: this.client.path("/me").method("post").create(),
            },
        };
        this.property = {};
        this.client.configure({ baseUrl, use: [this.authorizer] });
    }
    setAccessToken(access_token) {
        this.accessToken = access_token;
    }
}
export { PrivateApiClient };
